import PageLayer from "@/Layouts/views/PageLayer";
import FinancialStatementConfigLayer from "../../components/FinancialStatementConfig/FinancialStatementConfigLayer";

// MUI
import { Stack, SvgIcon } from "@mui/material";

// Icons
import { ReactComponent as Icon } from "@/assets/icons/header/settings/FinancialStatementIcon.svg";

export default function FinancialStatementConfig() {
	return (
		<PageLayer
			title="Financial Statement Configuration"
			icon={
				<Stack width={1} direction={"row"} justifyContent={"center"} alignItems={"center"}>
					<SvgIcon viewBox="-2 -2 24 24" className="text-[var(--strong-purple-color)] !text-[27px]" component={Icon} />
				</Stack>
			}
		>
			<FinancialStatementConfigLayer />
		</PageLayer>
	);
}
